/**
 * Page - Checkout JS
 */

// CSS
import styles from '../scss/page-checkout.scss';

const $ = window.jQuery;

// Components
import * as loading from 'js/components/loading';

// Toggle cart contents
$('html').on('click', '[data-toggle-cart-contents]', (event) => {
  $('.checkout-cart').toggleClass('content-is-visible');
});

// Sidebar coupon field (woocommerce/checkout/form-coupon.php).
// Posts to WooCommerce's apply_coupon endpoint directly: WC's own
// form.checkout_coupon handler hides the form on load and after every apply,
// and this field should stay visible.
$('html').on('submit', 'form.st-checkout-coupon', (event) => {
  const params = window.wc_checkout_params;

  if (!params) {
    return; // Fall back to the regular POST to the cart page.
  }

  event.preventDefault();

  const $form = $(event.currentTarget);
  const $input = $form.find('input[name="coupon_code"]');
  const $message = $form.find('.checkout-coupon-message');
  const couponCode = $input.val().trim();

  $message.removeClass('is-error is-success').text('');

  if (!couponCode) {
    $message.addClass('is-error').text('Please enter a coupon code.');
    $input.trigger('focus');
    return;
  }

  if ($form.hasClass('processing')) {
    return;
  }

  $form.addClass('processing');
  $form.find('button[type="submit"]').prop('disabled', true);

  $.ajax({
    type: 'POST',
    url: params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
    dataType: 'html',
    data: {
      security: params.apply_coupon_nonce,
      coupon_code: couponCode,
      billing_email: $('form.checkout input[name="billing_email"]').val(),
    },
    success: (response) => {
      const isError =
        response.indexOf('woocommerce-error') !== -1 ||
        response.indexOf('is-error') !== -1;
      const text = $($.parseHTML(response)).text().trim();

      $message.addClass(isError ? 'is-error' : 'is-success').text(text);

      if (!isError) {
        $input.val('');
        $(document.body).trigger('applied_coupon_in_checkout', [couponCode]);
        $(document.body).trigger('update_checkout', {
          update_shipping_method: false,
        });
      }
    },
    error: () => {
      $message
        .addClass('is-error')
        .text('We could not apply your coupon. Please try again.');
    },
    complete: () => {
      $form.removeClass('processing');
      $form.find('button[type="submit"]').prop('disabled', false);
    },
  });
});

// On the Sign In / Register step there is no form.checkout, so WooCommerce's
// update_checkout is a no-op. Reload so the sidebar shows the new total.
$(document.body).on(
  'applied_coupon_in_checkout removed_coupon_in_checkout',
  () => {
    if ($('form.checkout').length === 0) {
      window.location.reload();
    }
  }
);

// Login Form
$('html').on('submit', 'form[name="login"]', (event) => {
  event.preventDefault();

  const $form = $(event.currentTarget);
  let formError = false;
  let fields = {
    username: $form.find('input[name="username"]'),
    password: $form.find('input[name="password"]'),
    remember: $form.find('input[name="remember"]'),
    redirect: $form.find('input[name="redirect"]'),
    security: $form.find('input[name="security_login"]'),
  };

  $form.removeClass('form-has-error');

  if (!fields.username.val()) {
    formError = true;
    fields.username.closest('.form-group').addClass('has-error');
  } else {
    fields.username.closest('.form-group').removeClass('has-error');
  }

  if (!fields.password.val()) {
    formError = true;
    fields.password.closest('.form-group').addClass('has-error');
  } else {
    fields.password.closest('.form-group').removeClass('has-error');
  }

  if (!formError) {
    loading.show();

    var ajax_login_object = {
      ajax_url:
        'https://' + window.location.hostname + '/cms/wp-admin/admin-ajax.php',
      redirect_url: 'https://' + window.location.hostname,
    };

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: ajax_login_object.ajax_url,
      data: {
        action: 'wl_ajax_login_user',
        username: fields.username.val(),
        password: fields.password.val(),
        remember: fields.remember.val(),
        security: fields.security.val(),
        recaptcha_token:
          (document.querySelector('#recaptcha_input') &&
            document.querySelector('#recaptcha_input').value) ||
          'disabled',
      },
      success: (data) => {
        if (!data.success) {
          $form
            .find('.form-message')
            .addClass('form-error woocommerce-error')
            .text(data.message);
          $form.addClass('form-has-error');
        } else {
          $form.removeClass('form-has-error');
          $form
            .find('.form-message')
            .attr('class', 'form-message')
            .addClass('form-success woocommerce-message')
            .text(data.message);
          $form.addClass('form-has-success');
          document.location.href = fields.redirect.val()
            ? fields.redirect.val()
            : ajax_login_object.redirect_url;
        }
      },
      error: (resp) => {
        console.log(resp);
      },
      complete: (resp) => {
        loading.hide();
        scrollWindowTo('.woocommerce');
      },
    });
  } else {
    $form
      .find('.form-message')
      .addClass('form-error woocommerce-error')
      .text('Please fill in all required fields.');
    $form.addClass('form-has-error');
    scrollWindowTo('.woocommerce');
  }
});

// Registration form
$('html').on('submit', 'form[name="register"]', (event) => {
  event.preventDefault();

  const $form = $(event.currentTarget);
  let formError = false;
  let fields = {
    first_name: $form.find('input[name="first_name"]'),
    last_name: $form.find('input[name="last_name"]'),
    email: $form.find('input[name="email"]'),
    password: $form.find('input[name="password"]'),
    redirect: $form.find('input[name="redirect"]'),
    security: $form.find('input[name="security_registration"]'),
  };

  $form.removeClass('form-has-error');

  if (!fields.first_name.val()) {
    formError = true;
    fields.first_name.closest('.form-group').addClass('has-error');
  } else {
    fields.first_name.closest('.form-group').removeClass('has-error');
  }

  if (!fields.last_name.val()) {
    formError = true;
    fields.last_name.closest('.form-group').addClass('has-error');
  } else {
    fields.last_name.closest('.form-group').removeClass('has-error');
  }

  if (!fields.email.val()) {
    formError = true;
    fields.email.closest('.form-group').addClass('has-error');
  } else {
    fields.email.closest('.form-group').removeClass('has-error');
  }

  if (!fields.password.val()) {
    formError = true;
    fields.password.closest('.form-group').addClass('has-error');
  } else {
    fields.password.closest('.form-group').removeClass('has-error');
  }

  if (!formError) {
    loading.show();

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: ajax_login_object.ajax_url,
      data: {
        action: 'wl_ajax_register_user',
        first_name: fields.first_name.val(),
        last_name: fields.last_name.val(),
        email: fields.email.val(),
        password: fields.password.val(),
        security: fields.security.val(),
      },
      success: (data) => {
        if (!data.success) {
          $form
            .find('.form-message')
            .addClass('form-error woocommerce-error')
            .text(data.message);
          $form.addClass('form-has-error');
        } else {
          $form.removeClass('form-has-error');
          $form
            .find('.form-message')
            .attr('class', 'form-message')
            .addClass('form-success woocommerce-message')
            .text(data.message);
          $form.addClass('form-has-success');
          document.location.href = fields.redirect.val()
            ? fields.redirect.val()
            : ajax_login_object.redirect_url;
        }
      },
      error: (resp) => {
        console.log(resp);
      },
      complete: (resp) => {
        loading.hide();
        scrollWindowTo('.woocommerce');
      },
    });
  } else {
    $form
      .find('.form-message')
      .addClass('form-error woocommerce-error')
      .text('Please fill in all required fields.');
    $form.addClass('form-has-error');
    scrollWindowTo('.woocommerce');
  }
});

// Billing form
$('html').on('click', '.submit-billing', (event) => {
  event.preventDefault();

  const $form = $('#checkout-billing');
  let formError = false;

  $form.find('.form-row.validate-required:visible').each((i, el) => {
    let field = null;

    if ($(el).find('input').length > 0) {
      field = $(el).find('input');
    } else if ($(el).find('select').length > 0) {
      field = $(el).find('select');
    } else if ($(el).find('textarea').length > 0) {
      field = $(el).find('textarea');
    }

    if (field) {
      if (field.val() === '') {
        formError = true;
        let fieldName = $(el).find('label').text();
        fieldName = fieldName.replace(' *', '');

        if ($(el).find('.input-errors').length < 1) {
          $(el).append(
            `<div class="help-block input-errors">${fieldName} is required.</div>`
          );
          $(el).addClass('has-error woocommerce-invalid');
        }
      } else {
        $(el).find('.input-errors').remove();
        $(el).removeClass('has-error woocommerce-invalid');
      }
    }
  });

  if (formError) {
    $form
      .find('.form-message')
      .addClass('form-error woocommerce-error')
      .text('Please fill in all required fields.');
    $form.addClass('form-has-error');
    scrollWindowTo('.woocommerce');
    scrollWindowTo('.woocommerce');
  } else {
    $form.removeClass('form-has-error');
    $form.find('.form-message').attr('class', 'form-message').text('');
    $('#checkout-payment')
      .find('.woocommerce-invalid')
      .removeClass('woocommerce-invalid');
    $('.checkout-nav li, .checkout-step').removeClass('active');
    $('#checkout-payment, #nav-checkout-payment').addClass('active');
    scrollWindowTo('.woocommerce');
  }
});

// AvaTax address validation intercept for multi-step checkout.
// Manages a single MutationObserver with proper lifecycle (disconnect on
// success/error/timeout) to prevent memory leaks and duplicate handlers.
if ($('.wc_avatax_validate_address').length > 0) {
  const submitBilling = $('.submit-billing');
  let avataxObserver = null;
  let avataxTimeout = null;

  window.cleanupAvataxObserver = function () {
    if (avataxObserver) {
      avataxObserver.disconnect();
      avataxObserver = null;
    }
    if (avataxTimeout) {
      clearTimeout(avataxTimeout);
      avataxTimeout = null;
    }
  };

  window.validateAddress = function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    // AvaTax validation is only for US addresses
    if ($('#billing_country').val() !== 'US') {
      submitBilling.off('click', validateAddress);
      submitBilling.click();
      return;
    }

    // The AvaTax validate button is intentionally hidden via CSS in our
    // multi-step checkout, but we still trigger it programmatically so
    // AvaTax can calculate tax. Only skip if the button truly doesn't
    // exist, or if the cart is all virtual $0 items (nothing to tax).
    var $avataxBtn = $(
      '.woocommerce-billing-fields .wc_avatax_validate_address'
    );
    var avataxConfig = window.wc_avatax_frontend || {};
    if (!$avataxBtn.length || avataxConfig.cart_contains_only_virtual_zero) {
      submitBilling.off('click', validateAddress);
      submitBilling.click();
      return;
    }

    // Clean up any previous observer/timeout before creating new ones
    window.cleanupAvataxObserver();

    // Trigger the AvaTax validate button
    $avataxBtn.click();

    // Watch for the validation result (success OR error)
    avataxObserver = new MutationObserver(function (mutations_list) {
      mutations_list.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (added_node) {
          if (!added_node.classList) return;

          if (
            added_node.classList.contains(
              'wc-avatax-address-validation-success'
            )
          ) {
            // Validation succeeded — proceed to payment
            window.cleanupAvataxObserver();
            // Flag that our multi-step checkout validated the address.
            // This prevents the AvaTax #place_order handler from
            // racing with form submission (see stopPropagation below).
            window.stAvataxValidatedByMultiStep = true;
            submitBilling.off('click', validateAddress);
            submitBilling.click();
          } else if (
            added_node.classList.contains(
              'wc-avatax-address-validation-error'
            ) ||
            added_node.classList.contains('woocommerce-error')
          ) {
            // Validation failed — clean up and let user see the error
            window.cleanupAvataxObserver();
          }
        });
      });
    });

    avataxObserver.observe(
      document.querySelector('.woocommerce-billing-fields'),
      {
        subtree: true,
        childList: true,
      }
    );

    // Safety timeout: if nothing happens in 15 seconds, clean up and unblock
    avataxTimeout = setTimeout(function () {
      window.cleanupAvataxObserver();
      $('form.woocommerce-checkout').unblock();
      console.warn('[ST Checkout] AvaTax validation timed out after 15s');
    }, 15000);
  };

  submitBilling.on('click', validateAddress);

  // Prevent race condition: AvaTax's #place_order handler (on document) compares
  // form fields against its JS validatedAddress variable. If there's any mismatch
  // (ZIP+4 normalization, browser autocomplete, etc.), it fires invalidate_address()
  // WITHOUT preventing form submission — so WC submits the order while AvaTax
  // simultaneously invalidates the session, causing "Please validate your address."
  // Our multi-step checkout guarantees validation at the billing step — you can't
  // reach Place Order without passing it. Stop the click from reaching document
  // so the AvaTax handler never fires. WC uses the form 'submit' event, not click.
  $(document.body).on('click', '#place_order', function (e) {
    if (window.stAvataxValidatedByMultiStep) {
      e.stopPropagation();
    }
  });
}

$('html').on('click', '.toggle-account-forms', (event) => {
  event.preventDefault();

  scrollWindowTo('.woocommerce');
  $('.checkout-account-login').toggleClass('is-visible');
  $('.checkout-account-register').toggleClass('is-visible');
  resetFormErrors('#form-login');
  resetFormErrors('#form-register');
});

$('html').on('keydown', 'form[name="checkout"] input', (event) => {
  if (event.keyCode == 13) {
    event.preventDefault();
    return false;
  }
});

$('html').on('click', '.back-to-billing', (event) => {
  event.preventDefault();

  // Clean up any stale AvaTax observer from the payment step
  if (typeof window.cleanupAvataxObserver === 'function') {
    window.cleanupAvataxObserver();
  }
  // Clear the validation flag — user is back on billing, address may change
  window.stAvataxValidatedByMultiStep = false;

  // Re-attach the AvaTax intercept (off first to prevent duplicates)
  if (
    typeof validateAddress !== 'undefined' &&
    typeof validateAddress === 'function'
  ) {
    $('.submit-billing').off('click', validateAddress);
    $('.submit-billing').on('click', validateAddress);
  }

  $('.checkout-nav li, .checkout-step').removeClass('active');
  $('#checkout-billing, #nav-checkout-billing').addClass('active');
  scrollWindowTo('.woocommerce');
});

function scrollWindowTo(selector) {
  if (typeof selector !== 'undefined') {
    // Config
    let scrollOffset = 0;

    if ($(window).width() > 768) {
      scrollOffset = 74;
    }
    if ($(window).width() > 992) {
      scrollOffset = 114;
    }

    $('html, body').animate(
      {
        scrollTop: $(selector).offset().top - scrollOffset,
      },
      500
    );
  }
}

function resetFormErrors(form) {
  if (typeof form !== 'undefined') {
    $(form).removeClass('form-has-error');
    $(form).find('.form-group').removeClass('has-error');
  }
}
//Move Manage Payments and Payment Method Description
window.setTimeout(function () {
  const ccForm = $('#wc-authorize-net-cim-credit-card-credit-card-form');
  $('div.payment_method_authorize_net_cim_credit_card')
    .children('p')
    .last()
    .prependTo(ccForm);
  $('.wc-manage-payment-methods').prependTo(ccForm);
}, 6000);
